module.exports = __webpack_public_path__ + "img/h_s2e2_gallery_2.e9d61eba.png";